import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./pages/App";
import Alimtalk from "./pages/Alimtalk";
import WeeklyFireblight from "./pages/WeeklyFireblight";

import * as serviceWorker from "./serviceWorker";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/alimtalk" element={<Alimtalk />} />
                <Route path="/weekly-fireblight" element={<WeeklyFireblight />} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);

serviceWorker.unregister();